import CardElementPlaceholder from './CardElementPlaceholder';

export default CardElementPlaceholder;
